var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecurring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    className: "injected-svg",
    "data-src": "/assets/recurring_icon.svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "repeat-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon-9",
    d: "M10.0003 17.0833C13.9123 17.0833 17.0837 13.912 17.0837 9.99998C17.0837 7.64536 15.9348 5.55909 14.167 4.27115M10.8337 18.6666L9.16699 17L10.8337 15.3333M10.0003 2.91665C6.08831 2.91665 2.91699 6.08796 2.91699 9.99998C2.91699 12.3546 4.06588 14.4409 5.83366 15.7288M9.16699 4.66665L10.8337 2.99998L9.16699 1.33331",
    stroke: "#777777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurring);
export default __webpack_public_path__ + "static/media/recurring.0ec76b37dca45b49664f565428d827b1.svg";
export { ForwardRef as ReactComponent };